<template>
  <VForm
    v-model="filterData"
    class="box mb-30"
    ref="filter"
    @request="handleSubmit"
  >
    <div class="filter__input mb-30">
      <VInputDate
        label="Выберите период отчета"
        ref="filterDate"
      />

      <VSelect
        v-if="filters.isReclamationType || filters.isKppType"
        label="Тип отчета:"
        name="report_type"
        :options="typeOptions"
        :value="typeOptionDefault"
        :allow-empty="false"
      />

      <VSelect
        v-if="filters.isSpringType"
        label="Тип пружины:"
        :name="selectedReport.value === 'time-at-work' ? 'spring_type' : 'type'"
        :options="propertiesAll.product_type"
        multiple
      />

      <VSelect
        v-if="filters.isShape"
        label="Вид пружины"
        name="shape"
        :options="shapeAll"
        multiple
        isTooltip
        tooltipText="Данная фильтрация показывает актуальные значения от 11.04.24"
      />

      <VSelect
        v-if="filters.isOrderType"
        label="Тип заказа:"
        name="order_type"
        :options="propertiesAll.order_type"
        multiple
      />

      <VSelect
        v-if="filters.isPacker"
        label="Номер упаковщика:"
        name="packers"
        item-text="packer"
        :options="getPackagePackers"
        searchable
        multiple
      />

      <VSelect
        v-if="filters.isTypePacking"
        label="Вид тары:"
        name="package_type"
        :options="getPackageTypes"
        searchable
        multiple
      />

      <VSelect
        v-if="filters.isWorkshop"
        label="Цех производства:"
        name="workshop"
        multiple
        :options="workshopOptions"
        @change='setWorkshopSelected'
      />

      <VSelect
        v-if="filters.isMethodWinding"
        label="Способ навивки:"
        name="winding_method"
        :options="windingMethodOptionsFiltered"
        multiple
      />

      <VSelect
        v-if="filters.isMaterial"
        label="Марка стали:"
        name="material"
        :options="propertiesAll.material"
        multiple
      />

      <VSelect
        v-if="filters.isApplicationArea"
        label="Область применения:"
        name="application_area"
        :options="propertiesAll.application_area"
        multiple
      />

      <VSelect
        v-if="filters.isStage"
        label="Этап:"
        :name="selectedReport.value === 'time-at-work' ? 'status' : 'stage'"
        :options="propertiesAll.status"
        multiple
      />

      <VSelect
        v-if="filters.isResponsible"
        label="Ответственный:"
        :name="selectNameResponsible"
        :options="responsibleList"
        searchable
        multiple
      />

      <VSelect
        v-if="filters.isExecutor"
        label="Исполнитель:"
        name="executor"
        :options="executorList"
        searchable
        multiple
      />

      <VSelect
        v-if="filters.isDelayReason"
        label="Причина просрочки:"
        name="delay_reason"
        :options="propertiesAll['delay-reasons']"
        multiple
      />

      <VInput
        v-if="filters.isNumberOrder"
        label="№ заказа:"
        name="account_number"
      />

      <VSelect
        v-if="filters.isInnerReclamation"
        label="Внутренние рекламации:"
        name="is_inner_reclamation"
        placeholder="Показать все"
        :options="innerReclamationOptions"
      />
    </div>

    <VButton
      text="Сформировать"
      type="submit"
      color="primary"
      :loading="isLoading"
    />
  </VForm>
</template>

<script>
import VInputDate from '@/components/Form/VInputDate.vue'
import VSelect from '@/components/Form/VSelect.vue'
import VForm from '@/components/Form/VForm.vue'
import VButton from '@/components/simple/button/VButton.vue'
import { mixinWorkshopAndWindingMethodOptions } from '@/mixins/views/mixinWorkshopAndWindingMethodOptions'
import {
  RECLAMATION_INNER_REPORT_TYPE
} from '@/const/analytics'
import {
  KPP_TYPES
} from '@/const/analytics/kpp'
import getValuesArray from '@/utils/array/getValuesArray'
import { transformDateForSend } from '@/utils/form/date'
import { prepareFormDataIdArray } from '@/utils/form/prepareFormDataIdArray'
import { mapGetters, mapState } from 'vuex'
import { mapTrueFalseToOptions } from '@/utils/map/mapTrueFalseToOptions'
import VInput from '@/components/Form/Vinput/VInput.vue'

const innerReclamationOptions = [
  'отобразить только внутренние рекламации',
  'скрыть внутренние рекламации'
].map(mapTrueFalseToOptions)
export default {
  name: 'AnalyticsFilter',
  components: { VInput, VButton, VForm, VSelect, VInputDate },
  mixins: [mixinWorkshopAndWindingMethodOptions],
  props: {
    filters: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    selectedReport: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      filterData: {}
    }
  },
  computed: {
    ...mapState('users', {
      users: 'all'
    }),
    ...mapGetters('users', {
      executorList: 'executorList',
      stageResponsibleList: 'stageResponsibleList'
    }),
    ...mapGetters({
      propertiesAll: 'records/propertiesAll',
      shapeAll: 'records/shapeAll',
      getPackageTypes: 'records/getPackageTypes',
      getPackagePackers: 'records/getPackagePackers'
    }),

    responsibleList () {
      switch (this.selectedReport.value) {
        case 'stage':
          return this.stageResponsibleList
        default:
          return this.users
      }
    },

    selectNameResponsible () {
      switch (this.selectedReport.value) {
        case 'launched-orders-technical-department':
          return 'tech_manager'
        default:
          return 'responsible'
      }
    },

    typeOptions () {
      switch (this.selectedReport.value) {
        case 'time-at-work':
          return KPP_TYPES
        default:
          return RECLAMATION_INNER_REPORT_TYPE
      }
    },

    innerReclamationOptions: () => innerReclamationOptions,

    typeOptionDefault () {
      return this.typeOptions?.[0] || null
    }
  },

  watch: {
    typeOptionDefault: {
      immediate: true,
      handler (newValue) {
        if (newValue && !this.filterData.report_type) {
          this.$set(this.filterData, 'report_type', newValue)
        }
      }
    }
  },

  methods: {
    handleSubmit (data) {
      let params = { ...data }

      const dates = transformDateForSend(this.$refs.filterDate.$refs.dateRef?.defaultValue)
      params = { ...dates, ...params }
      const originalParams = { ...params }

      const keys2Ids = [
        'workshop',
        'application_area',
        'delay_reason',
        'executor',
        'inner_reclamation_type',
        'material',
        'order_type',
        'stage',
        'tech_manager',
        'type',
        'winding_method',
        'responsible',
        'shape',
        'package_type',
        'status',
        'spring_type'
      ]
      params = prepareFormDataIdArray(params, keys2Ids)

      if (params?.report_type) {
        params.type = params.report_type.value
        delete params.report_type
      }

      if (params?.packers) {
        params.packers = getValuesArray(params.packers, 'packer')
      }

      if (params?.is_inner_reclamation) {
        params.is_inner_reclamation = params.is_inner_reclamation.value
      }

      if (params?.account_number === '') {
        params.account_number = null
      }

      this.$emit('submit', params, originalParams)
    },

    clear () {
      this.filterData = {}
      this.$refs.filter.clear()
      this.$refs.filterDate.$refs.dateRef._flatpickr.clear()
    }
  }
}
</script>

<style scoped lang="scss">
.filter__input {
  display: flex;
  flex-wrap: wrap;
  //grid-template-columns: repeat(3, minmax(200px, 400px));
  gap: 25px;

  & > div {
    width: 100%;
    max-width: calc(100% / 3 - 16.67px);
  }
}
</style>
